import Icon from '../../ui/Icon/Icon';
import type { FaqItem } from '../../../locales/types';
import styles from './Faq.module.css';

export default function Faq({ items }: { items: FaqItem[] }) {
    return (
        <div className={styles.list}>
            {items.map((item) => (
                <details key={item.question} className={styles.item}>
                    <summary className={styles.question}>
                        <span>{item.question}</span>
                        <Icon name="chevronDown" className={styles.chevron} />
                    </summary>
                    <p className={styles.answer}>{item.answer}</p>
                </details>
            ))}
        </div>
    );
}
